import type { ErrorItem } from '../hooks/useErrorManagement'

export const noStockException = (productId: string) => [
	{
		message: `Item ${productId} without stock in default warehouse`,
		path: ['ItemWithoutStock'],
		extensions: {
			classification: 'DataFetchingException',
			parameters: {
				stock: false,
			},
		},
	},
]

export const isTokenError = (error: unknown): boolean =>
	Array.isArray(error) &&
	(error[0]?.message?.includes('TokenExpired') ||
		error[0]?.message?.includes('MalformedToken'))

export const getPath = (error: ErrorItem): string[] => {
	const path = error.extensions?.exception?.path || error.path
	if (path?.length) {
		return path
	}
	if (error.message) {
		return [error.message]
	}
	return ['']
}
